import axios from 'axios';

export const homeApi = async (url) => {
    let response = await axios.get(url+"/api/v1/getDkPage/homePage");
    return response.data;
}

export const previewApi = async (url) => {
    let response = await axios.get(url+"/api/v1/getDkPage/homePage");
    return response.data;
}